import React from 'react';
import { Alert, AlertTitle, Typography } from '@mui/material';

/**
 * Vysvětlení, proč na názvu vozidla záleží.
 *
 * Technika z poplachového e-mailu se páruje s číselníkem podle volacího znaku.
 * KOPIS ho ale občas nepošle (řádek pak končí pomlčkou, např. "CAS 20/4000/240-S2T Terrno -")
 * a vozidlo se v tom případě hledá podle názvu, a to přesnou shodou. Když se název
 * v číselníku liší, zůstane vozidlo nespárované a na poplachovém displeji se zobrazí
 * bez fotografie a SPZ. Bez téhle nápovědy je ta podmínka pro obsluhu neviditelná.
 */
const TechnikaParovaniInfo: React.FC = () => (
    <Alert severity="info" variant="outlined">
        <AlertTitle sx={{ fontWeight: 600 }}>Název musí odpovídat KOPIS</AlertTitle>
        <Typography variant="body2">
            Vozidlo se s poplachem páruje podle volacího znaku. Když ho KOPIS v e-mailu nepošle,
            hledá se vozidlo podle názvu — ten se proto musí přesně shodovat s názvem, který KOPIS
            posílá (například <strong>CAS 32/8200/800-S3R T815</strong>). Při jiném zápisu zůstane
            vozidlo nespárované a na poplachovém displeji bude bez fotografie a SPZ.
        </Typography>
    </Alert>
);

export default TechnikaParovaniInfo;
